class GoCoderZIsotope {
	constructor( container, params = {} ) {
		this.container = document.querySelector( container );
		this.wrapper = document.querySelector( params.wrapper );
		this.itemSelector = params.itemSelector;
		this.filterReset = this.wrapper.querySelector( ".js-isotope-filters-reset" );
		this.filters = this.wrapper.querySelectorAll( "input" );
		this.checkboxes = this.wrapper.querySelectorAll( "[type=\"checkbox\"]:not(.js-isotope-filters-reset)" );
		this.loadMoreBtn = this.wrapper.querySelector( ".js-isotope-load-more" );
		this.loadMoreAction = params.loadMoreAction;

		if ( params.hasOwnProperty( "sort" ) ) {
			this.sort = params.sort;
		} else {
			this.sort = {};
		}
		this.sortSelect = this.wrapper.querySelector( ".js-isotope-sort-select" );

		this.iso = new Isotope( this.container,
			Object.assign( {
				itemSelector: this.itemSelector,
				layoutMode: "fitRows"
			}, this.sort ) );

		this.Init();
	}

	Init() {
		this.filters.forEach( filter => this.HandlerFilterChange( filter ) );

		this.checkboxes.forEach( checkbox => this.HandlerCheckboxChange( checkbox ) );

		if ( this.sortSelect != null ) {
			this.sortSelect.addEventListener( "change", () => this.HandlerSortChange() );

			if ( $ ) {
				$( this.sortSelect ).on( "change", () => this.HandlerSortChange() );
			}
		}

		if ( this.filterReset != null ) {
			this.filterReset.addEventListener( "change", event => {
				let reset = event.target.checked;
				if ( reset ) {
					let checkboxes = this.wrapper.querySelectorAll( "[type=\"checkbox\"]:not(.js-isotope-filters-reset)" );
					checkboxes.forEach( checkbox => {
						checkbox.checked = false;
					} );
				}
			} );
		}

		this.loadMoreBtn.addEventListener( "click", ( event ) => {
			event.preventDefault();

			if ( ! this.loadMoreBtn.classList.contains( "is-loading" ) ) {
				this.loadMoreBtn.classList.add( "is-loading" );
				this.loadMoreBtn.classList.add( "cursor-not-allowed" );

				let tagsCheckboxes = this.wrapper.querySelectorAll( ".js-isotope-tags-container [type=\"checkbox\"]:checked:not(.js-isotope-filters-reset)" );
				let categoriesCheckboxes = this.wrapper.querySelectorAll( ".js-isotope-categories-container [type=\"checkbox\"]:checked:not(.js-isotope-filters-reset)" );
				let elements = this.wrapper.querySelectorAll( ".js-isotope-element" );
				let upcomingWebinars = document.querySelectorAll( ".js-webinar-upcoming" );
				let exclude = [];
				let tags = [];
				let categories = [];

				tagsCheckboxes.forEach( checkbox => {
					tags.push( checkbox.dataset.id );
				} );

				if ( categoriesCheckboxes != null ) {
					categoriesCheckboxes.forEach( checkbox => {
						categories.push( checkbox.dataset.id );
					} );
				}

				elements.forEach( element => {
					exclude.push( element.dataset.id );
				} );

				if ( upcomingWebinars != null ) {
					upcomingWebinars.forEach( element => {
						exclude.push( element.dataset.id );
					} );
				}

				exclude = exclude.filter( onlyUnique );

				const data = new FormData();

				data.append( "action", this.loadMoreAction );
				data.append( "nonce", gocoderzAjax.nonce );
				data.append( "categories", categories );
				data.append( "tags", tags );
				data.append( "exclude", exclude );

				let self = this;

				fetch( gocoderzAjax.url, {
					method: "POST",
					credentials: "same-origin",
					body: data
				} )
					.then( ( response ) => response.text() )
					.then( ( elements ) => {
						if ( elements ) {
							let div = document.createElement( "div" );
							div.innerHTML = elements.trim();
							while ( div.firstElementChild ) {
								let element = div.firstElementChild;
								if ( element != null ) {
									var hasClass = jQuery(div.firstElementChild).hasClass('js-load-more-btn');

									if( hasClass ) {
										var show_load_more_btn = jQuery(element).data('show');

										if( show_load_more_btn ){
											self.HideLoadMoreBtn();
										}
									}
									self.container.append( element );
									let fancy = element.querySelector( ".js-video-frame-facybox" );
									if ( fancy != null ) {
										$( fancy ).fancybox();
									}
									self.iso.appended( element );
									if ( self.sortSelect != null ) {
										self.iso.arrange( {
											sortBy: self.sortSelect.value
										} );
									}
								}
							}
							return true;
						} else {
							return false;
						}
					} )
					.then( added => {
						self.loadMoreBtn.classList.remove( "is-loading" );
						self.loadMoreBtn.classList.remove( "cursor-not-allowed" );
						return added;
					} )
					.catch( ( error ) => {
						console.error( error );
					} );
			}
		} );
	}

	HideLoadMoreBtn() {
		this.loadMoreBtn.classList.add( "d-none" );
	}

	ShowLoadMoreBtn() {
		this.loadMoreBtn.classList.remove( "d-none" );
	}

	HandlerSortChange() {
		this.ShowLoadMoreBtn();

		if ( ! this.loadMoreBtn.classList.contains( "is-loading" ) ) {
			this.loadMoreBtn.classList.add( "is-loading" );
			this.loadMoreBtn.classList.add( "cursor-not-allowed" );

			let elements = this.wrapper.querySelectorAll( ".js-isotope-element" );

			this.iso.remove( elements );
			this.container.style.height = "auto";

			let tagsCheckboxes = this.wrapper.querySelectorAll( ".js-isotope-tags-container [type=\"checkbox\"]:checked:not(.js-isotope-filters-reset)" );
			let categoriesCheckboxes = this.wrapper.querySelectorAll( ".js-isotope-categories-container [type=\"checkbox\"]:checked:not(.js-isotope-filters-reset)" );
			let tags = [];
			let categories = [];

			tagsCheckboxes.forEach( checkbox => {
				tags.push( checkbox.dataset.id );
			} );

			if ( categoriesCheckboxes != null ) {
				categoriesCheckboxes.forEach( checkbox => {
					categories.push( checkbox.dataset.id );
				} );
			}

			const data = new FormData();

			data.append( "action", this.loadMoreAction );
			data.append( "nonce", gocoderzAjax.nonce );
			data.append( "categories", categories );
			data.append( "tags", tags );
			data.append( "exclude", [] );
			if ( this.sortSelect != null ) {
				data.append( "sort", this.sortSelect.value );
			} else {
				data.append( "sort", "date" );
			}

			let self = this;

			fetch( gocoderzAjax.url, {
				method: "POST",
				credentials: "same-origin",
				body: data
			} )
				.then( ( response ) => response.text() )
				.then( ( elements ) => {
					if ( elements ) {
						let div = document.createElement( "div" );
						div.innerHTML = elements.trim();
						while ( div.firstElementChild ) {
							let element = div.firstElementChild;
							if ( element != null ) {
								self.container.append( element );
								let fancy = element.querySelector( ".js-video-frame-facybox" );
								if ( fancy != null ) {
									$( fancy ).fancybox();
								}
								self.iso.appended( element );
								if ( self.sortSelect != null ) {
									self.iso.arrange( {
										sortBy: self.sortSelect.value
									} );
								}
							}
						}
						return true;
					} else {
						return false;
					}
				} )
				.then( added => {
					self.loadMoreBtn.classList.remove( "is-loading" );
					self.loadMoreBtn.classList.remove( "cursor-not-allowed" );
					return added;
				} )
				.catch( ( error ) => {
					console.error( error );
				} );
		}
	}

	HandlerCheckboxChange( checkbox ) {
		checkbox.addEventListener( "change", () => {
			if ( this.filterReset != null ) {
				this.filterReset.checked = false;
				let changeEvent = new Event( "change" );
				this.filterReset.dispatchEvent( changeEvent );
			}
		} );
	}

	HandlerFilterChange( filter ) {
		filter.addEventListener( "change", () => this.UpdateLayout() );
	}

	UpdateLayout() {
		this.ShowLoadMoreBtn();
		let checkboxesValues = this.wrapper.querySelectorAll( "[type=\"checkbox\"]:checked" );
		let filterValue = [];

		checkboxesValues.forEach( checkbox => {
			let value = checkbox.value;
			let parent = checkbox.parentElement;
			if ( ! parent.classList.contains( "is-hidden" ) ) {
				filterValue.push( value );
			}
		} );

		if ( filterValue.length == 0 ) {
			this.ResetFilter();
		}

		let filterParams = {
			filter: filterValue.join( ", " )
		};

		if ( this.sortSelect != null ) {
			Object.assign( filterParams, {
				sortBy: this.sortSelect.value
			} );
		}

		this.iso.arrange( filterParams );
	}

	UpdateFilter( selector ) {
		let selectedElements = this.wrapper.querySelectorAll( selector );
		let checkboxes = this.wrapper.querySelectorAll( "[type=\"checkbox\"]:not(.js-isotope-filters-reset)" );
		let categoriesContainer = this.wrapper.querySelector( ".js-isotope-categories-container" );
		let tagsContainer = this.wrapper.querySelector( ".js-isotope-tags-container" );

		if ( categoriesContainer != null ) {
			categoriesContainer.classList.remove( "d-none" );
		}

		if ( tagsContainer != null ) {
			tagsContainer.classList.remove( "d-none" );
		}

		checkboxes.forEach( checkbox => {
			let parent = checkbox.parentElement;
			parent.classList.add( "is-hidden" );
		} );

		selectedElements.forEach( selected => {
			selected.classList.forEach( className => {
				if ( /tag-.*/.test( className ) ) {
					let checkbox = this.wrapper.querySelector( `[value=".${ className }"]` );
					if ( checkbox == null ) {
						this.AddTag( selected, className );
					} else {
						let parent = checkbox.parentElement;
						parent.classList.remove( "is-hidden" );
					}
				}

				if ( /category-.*/.test( className ) ) {
					let checkbox = this.wrapper.querySelector( `[value=".${ className }"]` );
					if ( checkbox == null ) {
						this.AddCategory( selected, className );
					} else {
						let parent = checkbox.parentElement;
						parent.classList.remove( "is-hidden" );
					}
				}
			} );
		} );

		if ( categoriesContainer != null ) {
			let categories = categoriesContainer.querySelectorAll( "[type=\"checkbox\"]:not(.js-isotope-filters-reset)" );

			if ( categories != null ) {
				let hiddenCount = 0;

				for ( let i = 0; i < categories.length; i++ ) {
					const category = categories[ i ];
					let parent = category.parentElement;

					if ( parent.classList.contains( "is-hidden" ) ) {
						hiddenCount++;
					}
				}

				if ( hiddenCount == categories.length ) {
					categoriesContainer.classList.add( "d-none" );
				}
			}
		}

		if ( tagsContainer != null ) {
			let tags = tagsContainer.querySelectorAll( "[type=\"checkbox\"]:not(.js-isotope-filters-reset)" );

			if ( tags != null ) {
				let hiddenCount = 0;

				for ( let i = 0; i < tags.length; i++ ) {
					const tag = tags[ i ];
					let parent = tag.parentElement;

					if ( parent.classList.contains( "is-hidden" ) ) {
						hiddenCount++;
					}
				}

				if ( hiddenCount == tags.length ) {
					tagsContainer.classList.add( "d-none" );
				}
			}
		}

		let selectedCheckboxes = this.wrapper.querySelectorAll( "[type=\"checkbox\"]:checked:not(.js-isotope-filters-reset)" );

		for ( let i = 0; i < selectedCheckboxes.length; i++ ) {
			const checkbox = selectedCheckboxes[ i ];
			let parent = checkbox.parentElement;

			if ( parent.classList.contains( "is-hidden" ) ) {
				checkbox.checked = false;
				let changeEvent = new Event( "change" );
				checkbox.dispatchEvent( changeEvent );
			}
		}
	}


	AddTag( selected, className ) {
		let selectedTags = JSON.parse( selected.dataset.tags );
		let tagName = "";
		let tagId = "";
		let tagAttribute = className;
		selectedTags.forEach( tag => {
			let tagClass = tag.name.replaceAll( " ", "" );
			tagClass = tagClass.replace( /[^a-zA-Z ]/g, "" );
			tagClass = tagClass.toLowerCase();
			className = className.replace( "tag-", "" );
			if ( className == tagClass ) {
				tagName = tag.name;
				tagId = tag.id;
			}
		} );

		let template = document.querySelector( ".js-global-tag" ),
			cloneTemplate = template.content.cloneNode( true );

		let input = cloneTemplate.querySelector( "input" );
		input.id = tagAttribute;
		input.value = `.${ tagAttribute }`;
		input.dataset.id = tagId;

		let label = cloneTemplate.querySelector( "label" );
		label.setAttribute( "for", tagAttribute );
		label.textContent = tagName;

		let container = this.wrapper.querySelector( ".js-isotope-tags-container" );
		container.appendChild( cloneTemplate );
		this.HandlerFilterChange( input );
		this.HandlerCheckboxChange( input );
	}

	AddCategory( selected, className ) {
		let selectedCategories = JSON.parse( selected.dataset.categories );
		let categoryName = "";
		let categoryId = "";
		let categoryAttribute = className;
		selectedCategories.forEach( category => {
			let categoryClass = category.name.replace( /[^a-zA-Z ]/g, "" );
			categoryClass = categoryClass.replaceAll( "-", "" );
			categoryClass = categoryClass.replaceAll( " ", "" );
			categoryClass = categoryClass.toLowerCase();
			className = className.replace( "category-", "" );
			if ( className == categoryClass ) {
				categoryName = category.name;
				categoryId = category.id;
			}
		} );

		let template = document.querySelector( ".js-global-tag" );
			cloneTemplate = template.content.cloneNode( true );

		let input = cloneTemplate.querySelector( "input" );
		input.id = categoryAttribute;
		input.value = `.${ categoryAttribute }`;
		input.dataset.id = categoryId;

		let label = cloneTemplate.querySelector( "label" );
		label.setAttribute( "for", categoryAttribute );
		label.textContent = categoryName;

		let container = this.wrapper.querySelector( ".js-isotope-categories-container" );
		container.appendChild( cloneTemplate );
		this.HandlerFilterChange( input );
		this.HandlerCheckboxChange( input );
	}

	ResetFilter() {
		if ( this.filterReset != null ) {
			this.filterReset.checked = true;
			let changeEvent = new Event( "change" );
			this.filterReset.dispatchEvent( changeEvent );
		}
	}
}

function onlyUnique( value, index, self ) {
	return self.indexOf( value ) === index;
}

export {
	GoCoderZIsotope
};